import { favouriteSortFilters } from "../Constants";
import { filterUnansweredQA } from "../utils";

const initialState = {
    data:[],
    pageNo:0,
    sortFilter:favouriteSortFilters[0],
    sortChange:false,
    domains:[],
    isLoading:false,
    totalCount:0,
    refresh:'refreshed',
    reload:'random',
    searchQuery:'',
    sortOptions: favouriteSortFilters,
    relevanceObj : {id:'3',value:"3",label:"Relevance", origValue:'relevance', sortOrder:'asc'},

}

const ShareWithPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "updateSharedWithSearchedQuery":
      state = {...state, pageNo:0};
      state = {...state, data:[]};
      state = {...state, searchQuery:payload};
      return state;
    case "updateSharedWithDomainValue":
      state = {...state, pageNo:0};
      state = {...state, data:[]};
      state = {...state, sortChange:true};
      state = {...state, domains:payload};
      return state;
    case "updateSharedWithSortFilterValue":
      state = {...state, pageNo:0};
      state = {...state, data:[]};
      state = {...state, sortChange:true};
      state ={...state, sortFilter:payload};
      return state;
    case 'reloadSharedWithtab':
      state = {...state,reload:payload };
      return state;
    case 'IsLoadingSharedWithtab':
      state = {...state,isLoading:payload };
      return state;
    case 'updateSharedWithTabData':
      if (payload.value === undefined) {
        let newData = [];
        if (state.pageNo === 0) {
          newData = filterUnansweredQA(payload.data);
        } else {
          newData = state.data.concat(filterUnansweredQA(payload.data));
        }
        state = { ...state, totalCount: payload.count }
        state = { ...state, data: newData };
        return state;
      }
      else {
        state = { ...state, totalCount: payload.count }
        state = { ...state, data: payload.data }
        return state;
      }
    case 'updatePageNoSharedWith':
      let randomVal = Math.random()*10;
      if(payload === 0){
        state = {...state, reload:randomVal.toString() }
        state = {...state, data:[]};
      }
      state = {...state, pageNo:payload};
      state = {...state, sortChange:false};
      return state;
    case 'markedSharedWithData':
      state = {...state,data:filterUnansweredQA(payload) };
      return state;
  default:
    return state
  }
}

export default ShareWithPageReducer;
